import { getPreferences } from '@orbit-mind/engine-react';
let audio: AudioContext | null = null;
let last = 0;
let sounding: OscillatorNode | null = null;
function vibrate(duration: number): void {
  const pulse = (navigator as Partial<Navigator>).vibrate;
  pulse?.call(navigator, [duration]);
}

/** Optional, local, bounded feedback; unsupported browsers keep the action working. */
export function touchFeedback(): void {
  if (document.visibilityState === 'hidden' || Date.now() - last < 80) return;
  last = Date.now();
  const prefs = getPreferences();
  try {
    if (prefs.touchVibration === true) vibrate(10);
    if (prefs.touchSound !== true || typeof AudioContext === 'undefined') return;
    audio ??= new AudioContext();
    const context = audio;
    void context
      .resume()
      .then(() => {
        if (getPreferences().touchSound !== true || document.visibilityState === 'hidden') return;
        sounding?.stop();
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.frequency.value = 700;
        gain.gain.setValueAtTime(0, context.currentTime);
        gain.gain.linearRampToValueAtTime(0.04, context.currentTime + 0.004);
        gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.045);
        oscillator.connect(gain);
        gain.connect(context.destination);
        sounding = oscillator;
        oscillator.onended = () => {
          oscillator.disconnect();
          gain.disconnect();
          if (sounding === oscillator) sounding = null;
        };
        oscillator.start();
        oscillator.stop(context.currentTime + 0.05);
      })
      .catch(() => undefined);
  } catch {
    /* Feedback cannot block the user's action. */
  }
}

export function stopTouchFeedback(): void {
  sounding?.stop();
  sounding = null;
  if (typeof navigator !== 'undefined') vibrate(0);
}
if (typeof document !== 'undefined')
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') stopTouchFeedback();
  });
